import { SyncProduct } from 'components/product/product-list/SyncProduct'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_SYNC_PRODUCT } from 'services/apiSyncProduct'
import { Alert } from 'avo-ui'
import icAlert from 'assets/images/ic-warning.svg'

const INIT_PROGRESS_DETAIL = {
    status: 'idle',
    count: {
        completed: 0,
        processing: 0,
        failed: 0,
    },
}

export const SyncProductContainer = ({ show, onHide, onSyncCompleted, selectedIds = [] }) => {
    const { fetching: checkProgress } = useFetch(API_SYNC_PRODUCT.CHECK)
    const { fetching: calculate } = useFetch(API_SYNC_PRODUCT.SYNC)
    const [progressDetail, setProgressDetail] = useState(INIT_PROGRESS_DETAIL)
    const [percentage, setPercentage] = useState(0)
    const [isCalculate, setIsCalculate] = useState(false)
    const [isRefresh, setIsRefresh] = useState(false)

    const getPercentage = (dataCount) => {
        return Math.round(((dataCount?.completed + dataCount?.failed) / dataCount?.total) * 100) || 0
    }

    const checkCompletedHandler = (dataCount) => {
        if (dataCount?.status === 'idle') {
            if (isCalculate) {
                onHide()
                onSyncCompleted()
                
                Alert({
                    icon: icAlert,
                    title: 'Success',
                    message: 'Sync Completed',
                    autoClose: true,
                    interval: 3000,
                })
            }

            setTimeout(async () => {
                setIsCalculate(false)
                setProgressDetail({ ...dataCount })
                // await API Last Sync
            }, 1000)
        } else {
            setProgressDetail({ ...dataCount })
            setIsCalculate(true)
        }
    }

    const checkProgressHandler = async () => {
        try {
            const currentProgress = await checkProgress()
            const percentage = getPercentage(currentProgress?.data?.count)
            setPercentage(percentage)
            checkCompletedHandler(currentProgress?.data)
        } catch (error) {
            if (error?.code === 'ERR_NETWORK' && isCalculate) setIsRefresh(true)
            setIsCalculate(false)
        }
    }

    useEffect(() => {
        checkProgressHandler().then()
    }, [])

    useEffect(() => {
        let timeout = null
        if (isCalculate && progressDetail?.status !== 'idle') {
            timeout = setTimeout(async () => {
                await checkProgressHandler()
            }, 3000)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [isCalculate, progressDetail])

    const onCalculate = () => {
        if (!isRefresh) {
            calculate({ product_ids: selectedIds }).then((response) => {
                setIsCalculate(true)
                setProgressDetail({ ...response.data })
            })
        } else {
            setIsCalculate(true)
        }
    }

    const props = {
        show,
        onHide,
        selectedCount: selectedIds?.length,
        onCalculate,
        progressDetail,
        percentage,
        isCalculate,
    }

    return <SyncProduct {...props} />
}
